export interface PaymentMethodOption {
  value: string;
  label: string;
  group: string;
}

export const PAYMENT_METHODS: PaymentMethodOption[] = [
  { value: "GCash", label: "GCash", group: "Philippine e-wallets" },
  { value: "Maya", label: "Maya", group: "Philippine e-wallets" },
  { value: "GrabPay", label: "GrabPay", group: "Philippine e-wallets" },
  { value: "ShopeePay", label: "ShopeePay", group: "Philippine e-wallets" },
  { value: "Coins.ph", label: "Coins.ph", group: "Philippine e-wallets" },
  { value: "GoTyme Bank", label: "GoTyme Bank", group: "Philippine transfers" },
  { value: "InstaPay", label: "InstaPay", group: "Philippine transfers" },
  { value: "PESONet", label: "PESONet", group: "Philippine transfers" },
  { value: "Bank transfer", label: "Bank transfer", group: "Banking" },
  { value: "Wise", label: "Wise", group: "International" },
  { value: "PayPal", label: "PayPal", group: "International" },
  { value: "Credit card", label: "Credit card", group: "Other" },
  { value: "Cash", label: "Cash", group: "Other" },
  { value: "Other", label: "Other", group: "Other" },
];
